import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox, HBox } from '../../../components/Box';
import { Modal } from '../../../components/Modal';

import { Button } from '../../../components/Buttons';
import { translateCountry } from '../../Companies/translate-countries';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import styles from './ChangeLocationModal.module.css';
import { Checkbox } from '../../../components/Checkbox';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import env from '../../../env';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';

import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import { AppClientId } from '../../Shared/constants';
import { setVehicleLocation } from '../actions';
import { VehicleCreateFieldCompany } from '../pages/create/FieldCompany';
import { fetchCompany } from '../../Companies/actions';
import AddressView from '../../Address/components/AddressView';
import { getPropByName } from '../../../utils/props';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const Address = styled.div`
  border: ${props => (!!props.isActive ? '1px solid rgb(21, 172, 121)' : '1px solid grey')};
  border-radius: 6px;
  padding: 12px;
  width: calc(50% - 10px);
  margin: 6px 0;
  font-size: 12px;
  min-height: 118px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;
class ChangeLocationModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      selectedCompany: props?.company ?? null,
      selectedAddress: props?.address ?? null,
      addressIsSaved: false, // New state property
    });
  }

  componentDidMount() {
    if (this.props.vehicle_details && this.props.company?.id) {
      this.props.fetchCompany(this.props.company?.id, result => {
        this.setState({ selectedCompany: result });
      });
    }
  }

  renderLocationButtons = () => {
    const { vehicle } = this.props;

    if (this.props.weblogin) return null;

    return (
      <>
        {vehicle?.location_address_id === '5' ? (
          <Button className={styles.buttonLinktree} onClick={() => this.props.setValueLocationAddress('5')}>
            {env.clientId === AppClientId.HOOIKAMMER
              ? this.lbl('vehicle.linktree.steenwijk')
              : env.clientId === AppClientId.HILTERMANN
              ? this.lbl('vehicle.linktree.grote_loods')
              : this.lbl('vehicle.linktree.home')}
          </Button>
        ) : (
          <Button
            className={styles.buttonChange}
            onClick={() => {
              this.setState({ addressIsSaved: true }); // Update state
              this.props.setValueLocationAddress('5', this.props.vehicleId, this.props.onClose);
            }}
          >
            {env.clientId === AppClientId.HOOIKAMMER
              ? this.lbl('vehicle.linktree.steenwijk')
              : env.clientId === AppClientId.HILTERMANN
              ? this.lbl('vehicle.linktree.grote_loods')
              : this.lbl('vehicle.linktree.home')}
          </Button>
        )}

        {env.clientId === AppClientId.HOOIKAMMER && (
          <div>
            {vehicle?.location_address_id === '390' ? (
              <Button
                className={styles.buttonLinktree}
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('5', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.opslag')}
              </Button>
            ) : (
              <Button
                className={styles.buttonChange}
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('390', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.opslag')}
              </Button>
            )}
            {vehicle?.location_address_id === '339' ? (
              <Button
                className={styles.buttonChange}
                primary
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('339', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.staphorst')}
              </Button>
            ) : (
              <Button
                className={styles.buttonChange}
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('339', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.staphorst')}
              </Button>
            )}
            {vehicle?.location_address_id === '570' ? (
              <Button
                primary
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('570', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.abcamsterdam')}
              </Button>
            ) : (
              <Button
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('570', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.abcamsterdam')}
              </Button>
            )}
            {vehicle?.location_address_id === '571' ? (
              <Button
                primary
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('571', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.reservelocatie')}
              </Button>
            ) : (
              <Button
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('571', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.reservelocatie')}
              </Button>
            )}
          </div>
        )}

        {env.clientId === AppClientId.HILTERMANN && (
          <div>
            {vehicle?.location_address_id === '4' ? (
              <Button
                className={styles.buttonLinktree}
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('4', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.kleine_loods')}
              </Button>
            ) : (
              <Button
                className={styles.buttonChange}
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('4', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.kleine_loods')}
              </Button>
            )}
            {vehicle?.location_address_id === '6' ? (
              <Button
                className={styles.buttonChange}
                primary
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('6', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.Parkeergarage')}
              </Button>
            ) : (
              <Button
                className={styles.buttonChange}
                onClick={() => {
                  this.setState({ addressIsSaved: true }); // Update state
                  this.props.setValueLocationAddress('6', this.props.vehicleId, this.props.onClose);
                }}
              >
                {this.lbl('vehicle.linktree.Parkeergarage')}
              </Button>
            )}
          </div>
        )}
      </>
    );
  };

  handleSetCompany = company => {
    this.setState({ selectedCompany: company });
    this.props.fetchCompany(company.id);
  };

  handleSetAddress = address => {
    this.setState({ selectedAddress: address });
  };

  render() {
    const { onClose, onConfirm } = this.props;

    if (this.props.vehicle_details) {
      return (
        <div className={styles.container}>
          <VBox left>
            <div className="mb-2 w-100">
              <VehicleCreateFieldCompany
                formField
                selectCompanyObj
                title={'relatie'}
                selectedCompanyId={this.state.selectedCompany?.id ?? ''}
                onChange={selectedCompany => {
                  this.handleSetCompany(selectedCompany);
                }}
              />
            </div>

            <HBox vCenter left flexWrap flip={window.innerWidth < 768} style={{ gap: 10 }}>
              {this.state.selectedCompany?.addresses?.map(address => (
                <AddressView
                  key={address?.id}
                  lbl={this.lbl}
                  address={address}
                  selectAddress={() => {
                    this.setState({ selectedAddress: address }, () => {
                      this.props.onConfirm(this.state.selectedCompany, this.state.selectedAddress);
                    });
                  }}
                  selected={this.state.selectedAddress?.id === address?.id}
                  company_name={getPropByName(this.state.selectedCompany, 'name')}
                />
              ))}
            </HBox>
          </VBox>
          <div className="d-flex justify-content-end">
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.props.onClose}>
              {this.lbl('cancel')}
            </ButtonComponent>
          </div>
        </div>
      );
    }

    return (
      <ModalComponent
        size={'modal-lg'}
        className={styles.modal}
        onClose={this.props.onClose}
        title={this.lblStr('vehicle.location.select')}
      >
        <div className={styles.container}>
          <VBox left>
            <label className="form-label">{this.lbl('relatie')}</label>
            <HBox vCenter left>
              {this.state.company?.name ?? this.props.company?.name}
            </HBox>
            <div className="mb-2 w-100">
              <CompanySelection
                changeLocation
                company={this.props.company ?? this.state.selectedCompany ?? ''}
                onSelect={selectedCompany => this.handleSetCompany(selectedCompany)}
              />
            </div>

            <HBox vCenter left flexWrap flip={window.innerWidth < 768} style={{ gap: 10 }}>
              {this.state.selectedCompany?.addresses?.map(address => (
                <Address
                  key={`${address?.id}`}
                  onClick={() => (this.props.invoiceData && !address.country ? null : this.handleSetAddress(address))}
                  isActive={this.state.selectedAddress?.id === address?.id}
                >
                  <VBox left>
                    <HBox vCenter>
                      <h6 className="name">{this.lbl(`address.type.${address?.type?.name || 'other'}`)}</h6>
                      <CheckboxComponent checked={this.state.selectedAddress?.id === address?.id} />
                    </HBox>
                    <VBox className="address" left>
                      <div>{address?.addressLine1}</div>
                      <div>
                        {address?.postcode} {address?.city}
                      </div>
                      <div>{translateCountry(address.country?.name, this.locale)}</div>
                      {this.props.invoiceData && !address.country && (
                        <div style={{ color: 'red' }}>{'Country is required *'}</div>
                      )}
                    </VBox>
                  </VBox>
                </Address>
              ))}
            </HBox>
            <div>{this.renderLocationButtons()}</div>
          </VBox>
          <div className="d-flex gap-2 mt-4">
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.props.onClose}>
              {this.lbl('cancel')}
            </ButtonComponent>
            <ButtonComponent
              style={'ButtonSoftEdit'}
              onClick={() => this.props.onConfirm(this.state.selectedCompany, this.state.selectedAddress)}
            >
              {this.lbl('confirm')}
            </ButtonComponent>
          </div>
        </div>
      </ModalComponent>
    );
  }
}

ChangeLocationModalComp.propTypes = {
  vehicleId: PropTypes.string.isRequired, // Add vehicleId as a required prop
  company: PropTypes.object,
  address: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  fetchCompany: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  setValueLocationAddress: PropTypes.func.isRequired,
};
const mapStateToProps = state =>
  createStructuredSelector({
    locale: makeSelectLocale(),
  });

const mapDispatchToProps = dispatch => ({
  fetchCompany: (id, cb) => dispatch(fetchCompany(id, cb)),

  changeLocation: (vehicleId, companyId, addressId, addressIsSaved) => {
    if (!addressIsSaved) {
      console.warn('Address change is not allowed because it is not saved.');
      return;
    }
    console.warn('Address change is allowed because it is not saved.');

    dispatch(setVehicleLocation(vehicleId, companyId, addressId));
  },

  setValueLocationAddress: (addressId, vehicleId, onClose) => {
    if (env.clientId === AppClientId.HARRY_NIJBOER) {
      dispatch(setVehicleLocation(vehicleId, '28', '29'));
      onClose && onClose(); // Ensure onClose is defined before calling
    } else {
      console.log('vehicleId', vehicleId, 'addressId', addressId);
      dispatch(setVehicleLocation(vehicleId, '4', addressId));
      onClose && onClose(); // Ensure onClose is defined before calling
    }
  },
});

export const ChangeLocationModal = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  injectIntl,
)(ChangeLocationModalComp);
